// src/@chakra-ui/gatsby-plugin/theme.js
import { extendTheme } from '@chakra-ui/react'

const theme = {
    styles: {
        global: () => ({
          body: {
            bg: ""
          },
          ":where( blockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre )" : {
            margin: "none"
          },
        })
    }
}

export default extendTheme(theme)
export const baseTheme = {}